import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { accessCheck } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";

export default function EmailGate({ projectId, onGranted }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [projectName, setProjectName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await accessCheck(projectId, email.trim().toLowerCase());
      setProjectName(res.project_name || "");
      if (!res.granted) {
        toast.error("This email is not on the distribution list for this project");
        return;
      }
      localStorage.setItem(`pg_email_${projectId}`, email.trim().toLowerCase());
      onGranted(email.trim().toLowerCase(), res.role);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Project not found");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-slate-50 flex items-center justify-center px-4" data-testid="email-gate">
      <div className="w-full max-w-md bg-white border border-slate-300 rounded-md shadow-[0_8px_32px_rgba(15,23,42,0.04)] p-8 fade-up">
        <div className="h-12 w-12 rounded-md bg-slate-950 text-white flex items-center justify-center mb-5">
          <ShieldCheck size={22} weight="fill" />
        </div>
        <h1 className="font-display text-2xl font-black tracking-tight">Verify your email</h1>
        <p className="text-sm text-slate-600 mt-2 leading-relaxed">
          {projectName ? `"${projectName}" is access-restricted. ` : ""}
          Enter the email address that the project admin added to the distribution list.
        </p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-ibm">Your Email</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              autoFocus
              className="h-11 rounded-md border-slate-300 focus-visible:ring-0 focus-visible:border-slate-950"
              data-testid="email-gate-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 bg-slate-950 hover:bg-slate-800 text-white rounded-md font-medium"
            data-testid="email-gate-submit"
          >
            {loading ? "Verifying…" : (
              <span className="flex items-center gap-2 justify-center">
                Continue <ArrowRight size={16} weight="bold" />
              </span>
            )}
          </Button>
        </form>

        <p className="mt-5 text-[11px] text-slate-500 font-mono-ibm uppercase tracking-widest">
          Project ID: {projectId.slice(0, 8)}…
        </p>
      </div>
    </div>
  );
}
